module.exports = __webpack_public_path__ + "img/82.5666b39f.jpg";